// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__yxYGQ","noInteraction":"EventWrapper_noInteraction__TvMwH"};